import styles from "./styles.module.scss";

interface PartnershipCardProps {
  paragraph: string;
  cardNumber: string;
  numberColor: string;
  paragraphColor: string;
  backgroundColor: string;
}
export default function PartnershipCard({
  paragraph,
  cardNumber,
  numberColor,
  paragraphColor,
  backgroundColor,
}: PartnershipCardProps) {
  return (
    <li
      className={styles.container}
      style={{ backgroundColor: backgroundColor }}
    >
      <span style={{ color: numberColor }}>{cardNumber}</span>
      <p style={{ color: paragraphColor }}>{paragraph}</p>
    </li>
  );
}
